import React, { Component } from 'react';
import Helmet from "react-helmet";
import { inject, observer } from 'mobx-react';
import { Redirect } from 'react-router-dom';
import HomeSlider from '../../components/homeSlider/';
import Banner from '~/components/banner';

@inject('appStore')
@observer
export default class Home extends Component{

    state = {
        isShowBanner: true
    }

    hideBanner = () => {
        this.setState({
            isShowBanner: false
        })
    }

    render() {
    const {cardReader, initData: {hideHomePage} } = this.props.appStore;

    if (hideHomePage) return <Redirect to="/live" />;

    return(
        <div className="home">
            <Helmet>
                <title>ИРМ</title>
            </Helmet>
            {this.state.isShowBanner ? (<Banner hideBanner={this.hideBanner} />) : null}
            <div className="left_col">
            <HomeSlider />
            </div>
            <div className="right_col">
            <div className="right_col__head">
                <div className="benefit">
                    <span className="benefit__img">
                        <img src="/assets/img/home/men_1.svg" alt="" className="img benefit__img_1"/>
                    </span>
                    <span className="benefit_text">Пройдите<br/> регистрацию<br/> в кассе</span>
                </div>
                <div className="benefit">
                    <span className="benefit__img">
                        <img src="/assets/img/home/card_2.svg" alt="" className="img benefit__img_2"/>
                    </span>
                    <span className="benefit_text">Получите<br/> клубную карту</span>
                </div>
                <div className="benefit">
                    <span className="benefit__img">
                        <img src="/assets/img/home/wallet_3.svg" alt="" className="img benefit__img_3"/>
                    </span>
                    <span className="benefit_text">Пополните<br/> игровой счет</span>
                </div>
                <div className="benefit">
                    <span className="benefit__img">
                        <img src="/assets/img/home/user_id_4.svg" alt="" className="img benefit__img_4"/>
                    </span>
                    <span className="benefit_text">Идентифицируйте<br/> с помощью карты</span>
                </div>
            </div>
            { cardReader   ? 
            <div className="right_col__foot">
                <div className="benefit">
                    <span className="benefit__img">
                        <img src="/assets/img/home/nfc.svg" alt="" className="img benefit__img_5"/>
                    </span>
                    <span className="benefit_text">Приложите карту<br/> к считывающему устройству.</span>
                </div>
            </div>
            : '' }
        </div>
        </div>
    )
    }
}


// WEBPACK FOOTER //
// ./src/routes/home/index.js